<template>
  <ConfirmDialog :name="modalName">
    You won’t be able to restore your comment
    <template slot="actions">
      <BravadoButtonV3 data-test="cancel-button" variant="secondary" @click="hideModal">Cancel</BravadoButtonV3>
      <BravadoButtonV3 data-test="confirm-button" variant="danger" @click="confirmRemove">Remove</BravadoButtonV3>
    </template>
  </ConfirmDialog>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapActions } from 'vuex';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import ConfirmDialog from '~/components/common/ConfirmDialog.vue';

export default Vue.extend({
  name: 'WarRoomConfirmRemoveComment',
  components: { ConfirmDialog, BravadoButtonV3 },
  data() {
    return {
      modalName: 'confirm-remove-comment',
    };
  },
  methods: {
    ...mapActions('warRoom', ['removeComment']),
    async confirmRemove() {
      const commentId = this.$route.query.commentId;
      if (commentId) {
        try {
          await this.removeComment({ commentId });
        } catch (e) {
          this.$notice.error('Could not remove comment', e);
          this.$sentryUtils.error(e);
        }
      }

      this.hideModal();
    },
    async hideModal() {
      const query = { ...this.$route.query };
      delete query.dynamic_modal;
      delete query.commentId;

      await this.$router.replace({ query });
    },
  },
});
</script>
